/**
 * @title Does Cookie Exist?
 * @description Checks whether or not a given cookie exists.
 * @param {string} cookieName - The name of the cookie
 */
export function doesCookieExist(cookieName) {
	if (document.cookie.split("; ").find((row) => row.startsWith(cookieName))) return true;

	return false;
}
